/* translate ts: https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/localizejs-library/index.d.ts has a wrong api return value.
   According to the OG library iut should return a string https://help.localizejs.com/docs/library-api#returns
*/
export const translate = (text: string) => {
  return window.Localize ? (window.Localize.translate(text) as unknown as string) : text;
};
